/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface ExtractSentenceRequest
 */
export interface ExtractSentenceRequest {
    /**
     * 
     * @type {string}
     * @memberof ExtractSentenceRequest
     */
    text?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExtractSentenceRequest
     */
    entities?: Array<string>;
}

/**
 * Check if a given object implements the ExtractSentenceRequest interface.
 */
export function instanceOfExtractSentenceRequest(value: object): boolean {
    return true;
}

export function ExtractSentenceRequestFromJSON(json: any): ExtractSentenceRequest {
    return ExtractSentenceRequestFromJSONTyped(json, false);
}

export function ExtractSentenceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExtractSentenceRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'text': json['text'] == null ? undefined : json['text'],
        'entities': json['entities'] == null ? undefined : json['entities'],
    };
}

export function ExtractSentenceRequestToJSON(value?: ExtractSentenceRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'text': value['text'],
        'entities': value['entities'],
    };
}

